import { Button, Modal, ModalSection, Tabs } from '@monash/portal-react';
import { useState } from 'react';
import StatusFilters from './status-filters/StatusFilters';
import CategoryFilters from './category-filters/CategoryFilters';
import CohortFilters from './cohort-filters/CohortFilters';
import c from './filters-modal.module.scss';

const TAB_ID = {
  STATUS: 'Status',
  CATEGORY: 'Category',
  COHORT: 'Cohort',
};

const FiltersModal = ({
  onClose,
  statusFilterOptions,
  selectedStatuses,
  onChangeStatuses,
  categoryFilterOptions,
  selectedCategories,
  onChangeCategories,
  cohortFilterOptions,
  selectedCohorts,
  onChangeCohorts,
  ...modalProps
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  // Tab should only be rendered if their required props are given
  const tabsOrder = [
    {
      id: TAB_ID.STATUS,
      title: 'Status',
      shouldRender: statusFilterOptions && selectedStatuses && onChangeStatuses,
    },
    {
      id: TAB_ID.CATEGORY,
      title: 'Categories',
      shouldRender:
        categoryFilterOptions && selectedCategories && onChangeCategories,
    },
    {
      id: TAB_ID.COHORT,
      title: 'Location and cohort',
      shouldRender: cohortFilterOptions && selectedCohorts && onChangeCohorts,
    },
  ];

  const filteredTabsOrder = tabsOrder.filter((tab) => tab.shouldRender);
  const selectedTabId = filteredTabsOrder[selectedTabIndex].id;

  return (
    <Modal className={c.modalCard} onClose={onClose} {...modalProps}>
      <ModalSection title="Select filters">
        <div className={c.modalContent}>
          <div>
            <Tabs
              tabs={filteredTabsOrder.map((tab) => tab.title)}
              selected={selectedTabIndex}
              onChange={setSelectedTabIndex}
            />
          </div>
          <div className={c.tabPanelContainer}>
            {selectedTabId === TAB_ID.STATUS && (
              <StatusFilters
                options={statusFilterOptions}
                value={selectedStatuses}
                onChange={onChangeStatuses}
              />
            )}
            {selectedTabId === TAB_ID.CATEGORY && (
              <CategoryFilters
                options={categoryFilterOptions}
                value={selectedCategories}
                onChange={onChangeCategories}
              />
            )}
            {selectedTabId === TAB_ID.COHORT && (
              <CohortFilters
                options={cohortFilterOptions}
                value={selectedCohorts}
                onChange={onChangeCohorts}
              />
            )}
          </div>
          <div className={c.footer}>
            <Button onClick={onClose}>Done</Button>
          </div>
        </div>
      </ModalSection>
    </Modal>
  );
};

export default FiltersModal;
